/*
  <card-before-after> — the mobile before/after strip on collection product cards.
  Markup and the desktop hover come from snippets/card-product.liquid; the swipe itself
  is native scroll-snap (assets/norse-card-before-after.css). This file does only what
  CSS cannot:

  - A tap opens the product. On mobile the strip sits above the card's link overlay so
    it can scroll, so the overlay no longer catches the tap. Browsers do not fire
    `click` for a touch that turned into a scroll, so `click` on the strip means
    exactly "tapped, not swiped".
  - The dots follow the scroll position, and scroll to their slide.
*/
if (!customElements.get('card-before-after')) {
  customElements.define(
    'card-before-after',
    class CardBeforeAfter extends HTMLElement {
      connectedCallback() {
        // Moving the element re-runs this; the listeners must only be bound once.
        if (this.track) return;
        this.track = this.querySelector('.media');
        this.dots = Array.from(this.querySelectorAll('.card-before-after__dot'));
        if (!this.track || !this.dots.length) return;

        this.track.addEventListener('click', () => this.openProduct());
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
      }

      openProduct() {
        const link = this.closest('.card')?.querySelector('.card__heading a[href]');
        if (link) link.click();
      }

      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const width = this.track.clientWidth;
          if (width) this.setCurrent(Math.round(this.track.scrollLeft / width));
        });
      }

      setCurrent(index) {
        this.dots.forEach((dot, i) => {
          if (i === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      goTo(index) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({
          left: index * this.track.clientWidth,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }
    }
  );
}
